import { type ComponentProps } from 'react';
import { Icon } from '@plone/components';

const CartSVG = (props: Omit<ComponentProps<typeof Icon>, 'children'>) => {
  return (
    <Icon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 600">
        <path
          fill="currentColor"
          d="M139.9 170.3c-4.2 0-8-2.8-9.2-7L94.2 26.7H16.4c-5.2 0-9.5-4.3-9.5-9.5s4.3-9.5 9.5-9.5h85.1c4.3 0 8.1 2.9 9.2 7l38.4 143.6c1.4 5.1-1.7 10.3-6.7 11.6-.9.3-1.7.4-2.5.4zm372.7 421.8c-7.4 0-14.9-1.7-21.9-5.2-24-12.1-33.7-41.5-21.6-65.5 5.9-11.6 15.9-20.3 28.3-24.4 12.4-4.1 25.6-3.1 37.2 2.8 11.6 5.9 20.3 15.9 24.4 28.3 4.1 12.4 3.1 25.6-2.8 37.2-8.5 17-25.7 26.8-43.6 26.8zm-26.5-62.2c-7.4 14.7-1.5 32.6 13.2 40 7.1 3.6 15.2 4.2 22.7 1.7 7.6-2.5 13.7-7.8 17.3-14.9 3.6-7.1 4.2-15.2 1.7-22.7s-7.8-13.7-14.9-17.3c-14.6-7.4-32.6-1.5-40 13.2zm-276 62.2c-1.6 0-3.2-.1-4.9-.2-26.8-2.7-46.4-26.6-43.7-53.4 1.3-13 7.6-24.7 17.6-32.9 10.1-8.3 22.8-12.1 35.7-10.8 13 1.3 24.6 7.6 32.9 17.6 8.3 10.1 12.1 22.8 10.8 35.7-2.4 25.2-23.6 44-48.4 44zm-.1-78.6c-6.9 0-13.4 2.3-18.8 6.7-6.2 5-10 12.2-10.8 20.1-1.6 16.3 10.3 31 26.7 32.6 16.4 1.6 31-10.3 32.6-26.7.8-7.9-1.6-15.7-6.6-21.8-5-6.2-12.2-10-20.1-10.8-1 0-2-.1-3-.1z"
        />
        <path
          fill="currentColor"
          d="M512.7 513.3H211.2c-26.3 0-47.7-21.4-47.7-47.7 0-26.3 21.4-47.7 47.7-47.7 5.2 0 9.5 4.3 9.5 9.5s-4.3 9.5-9.5 9.5c-15.8 0-28.7 12.9-28.7 28.7 0 15.8 12.9 28.7 28.7 28.7h301.5c5.2 0 9.5 4.3 9.5 9.5s-4.3 9.5-9.5 9.5z"
        />
        <path
          fill="currentColor"
          d="M511.1 436.9H210.5c-4.3 0-8.1-2.9-9.2-7.1l-70.6-266.7c-.8-2.9-.1-5.9 1.7-8.2s4.6-3.7 7.5-3.7h441.7c2.9 0 5.7 1.4 7.5 3.7 1.8 2.3 2.4 5.4 1.7 8.2l-70.6 266.7c-1.1 4.2-4.8 7.1-9.1 7.1zm-293.3-19h286l65.5-247.7h-417l65.5 247.7z"
        />
        <path
          fill="currentColor"
          d="M388.7 170.3c-5.2 0-9.5-4.3-9.5-9.5V26.9H219.6v133.9c0 5.2-4.3 9.5-9.5 9.5s-9.5-4.3-9.5-9.5V17.4c0-5.2 4.3-9.5 9.5-9.5h178.6c5.2 0 9.5 4.3 9.5 9.5v143.4c0 5.2-4.3 9.5-9.5 9.5z"
        />
        <path
          fill="currentColor"
          d="M508.6 170.3c-5.2 0-9.5-4.3-9.5-9.5V97.4H388.7c-5.2 0-9.5-4.3-9.5-9.5s4.3-9.5 9.5-9.5h119.9c5.2 0 9.5 4.3 9.5 9.5v72.9c0 5.2-4.3 9.5-9.5 9.5z"
        />
      </svg>
    </Icon>
  );
};

export default CartSVG;
